import { fetch } from 'libs/fetch';
/**
 * 获取商品信息
 */
export async function getSupplierSkuInfoList(json?: any) {
  const res = await fetch('/api/mall/v1/supplierSku/admin/getSupplierSkuList', {
    method: 'POST',
    json,
    needLogin: false,
  });
  return res;
}

/**
 * 是否展示询价按钮
 */
export async function displayEnquireButton(supplierSysNo): Promise<APIJSON<any>> {
  return fetch(`/api/tender/v1/orderTradeEnquire/displayEnquireButton/${supplierSysNo}`, {
    needLogin: false,
    method: 'GET',
  });
}

/**
 * 更新或保存用户加入询价记录
 */
export async function addOrderTradeEnquire(json?: any) {
  const res = await fetch('/api/tender/v1/orderTradeEnquire/add/sku', {
    method: 'POST',
    json,
  });
  return res;
}

/**
 * 查询询价单列表
 */
export async function getOrderTradeEnquireSkuList(): Promise<APIJSON<any>> {
  return fetch(`/api/tender/v1/orderTradeEnquire/sku/list`, {
    needLogin: true,
    method: 'GET',
  });
}

/**
 * 查询询价单列表
 */
export async function searchOrderTradeEnquiryList(json) {
  const res = await fetch('/api/tender/v1/orderTradeEnquire/searchOrderTradeEnquiryList', {
    method: 'POST',
    json,
  });
  return res;
}

/**
 * 查询询价单详情
 */
export async function getOrderTradeEnquireDetail(sysNo): Promise<APIJSON<any>> {
  return fetch(`/api/tender/v1/orderTradeEnquire/get/${sysNo}`, {
    needLogin: true,
    method: 'GET',
  });
}

/**
 * 保存询价单
 */
export async function saveOrderTradeEnquiry(json) {
  const res = await fetch('/api/tender/v1/orderTradeEnquire/save', {
    method: 'POST',
    json,
    needLogin: false,
  });
  return res;
}

/**
 * 删除用户加入询价记录
 */
export async function deleteOrderTradeEnquiry(json) {
  const res = await fetch('/api/tender/v1/orderTradeEnquire/sku/delete', {
    method: 'POST',
    json,
  });
  return res;
}

/**
 * 删除用户加入询价记录
 */
export async function replyOrCancelEnquire(json) {
  const res = await fetch('/api/tender/v1/orderTradeEnquire/replyOrCancelEnquire', {
    method: 'POST',
    json,
  });
  return res;
}
